<!--
 * @Description: 短信账户
 * @Version: 1.0
 * @Autor: zhaoyy
 * @Date: 2022-08-22 10:34:56
 * @LastEditors: zhaoyy
 * @LastEditTime: 2023-03-23 17:25:46
-->
<template>
  <div class="message-account">
    <div class="account-info">
      <div class="info-item-title">
        <span class="title-left"></span>
        <span class="title-label">短信账户信息</span>
        <span class="accountId">
          （账户ID：{{ selectApp }}）
          <!-- <el-select v-model="selectApp" @change="appChange" size="small" style="width: 200px;">
            <el-option
              v-for="item in appList"
              :key="item.id"
              :label="item.appName"
              :value="item.id">
            </el-option>
          </el-select> -->
        </span>
      </div>
      <div class="info-item-content">
        <div class="info-item-content_top">
          <p>短信账户余额：{{ stockNum }}（条）</p>
          <el-button type="text" @click="balanceSettingVisible = true"
            >余额预警</el-button
          >
        </div>
        <el-button type="primary" size="small" @click="buyMessage"
          >购买</el-button
        >
      </div>
    </div>
    <div class="account-buy">
      <div class="buy-item-title info-item-title">
        <span class="title-left"></span>
        <span>短信购买流程</span>
      </div>
      <div class="buy-item-step">
        <div class="step-item">
          <img src="@/assets/images/message/messagepackage.png" alt="" />
          <p class="step-item-label">点击购买按钮，选择购买的短信包。</p>
        </div>
        <div class="line">
          <img src="@/assets/images/message/payarrow.png" alt="" srcset="" />
        </div>
        <div class="step-item">
          <img src="@/assets/images/message/paycode.png" alt="" />
          <p class="step-item-label">扫码支付</p>
        </div>
        <div class="line">
          <img src="@/assets/images/message/payarrow.png" alt="" srcset="" />
        </div>
        <div class="step-item">
          <img src="@/assets/images/message/buysuccess.png" alt="" />
          <p class="step-item-label">购买成功，短信到账</p>
        </div>
      </div>
      <div class="buy-item-content">
        <div class="buy-item-content-title">收款账户信息</div>
        <div class="buy-item-content-row">
          <span class="buy-item-content-item">账户名：</span>
          <span>上海兔有其裹网络科技有限公司</span>
        </div>
        <div class="buy-item-content-row">
          <span class="buy-item-content-item">账号：</span>
          <span>121946223510201</span>
        </div>
        <div class="buy-item-content-row">
          <span class="buy-item-content-item">开户银行：</span>
          <span>招商银行股份有限公司上海青浦支行</span>
        </div>
      </div>
    </div>
    <div v-if="dialogVisible">
      <el-dialog
        :visible.sync="dialogVisible"
        title="购买"
        :close-on-click-modal="false"
        custom-class="buy-dialog"
        width="948px"
      >
        <el-form
          :model="dialogForm"
          label-position="left"
          label-width="143px"
          size="small"
          :rules="rules"
          ref="buyInfoForm"
        >
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="短信包">
                <el-radio-group
                  v-model="dialogForm.payType"
                  @change="payTypeChange"
                >
                  <el-radio label="1" border
                    >1000<span class="unit">条</span></el-radio
                  >
                  <el-radio label="2" border
                    >2000<span class="unit">条</span></el-radio
                  >
                  <el-radio label="3" border
                    >5000<span class="unit">条</span></el-radio
                  >
                  <el-radio label="4" border
                    >10000<span class="unit">条</span></el-radio
                  >
                  <el-radio label="5" border class="customize-radio"
                    >自定义数量</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="dialogForm.payType === '5'">
            <el-col :span="24">
              <el-form-item label="自定义数量" prop="number">
                <el-input v-model="dialogForm.number" @input="numberChange">
                  <template slot="append">条</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="合计金额" class="count-price">
                <span class="price-unit">￥</span>
                <span class="price-total">{{ totalPrice }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-button
          type="primary"
          size="small"
          @click="buyNow"
          class="buy-now-button"
          >立刻购买</el-button
        >
      </el-dialog>
    </div>
    <div v-if="payDialogVisible">
      <el-dialog
        :visible.sync="payDialogVisible"
        title="收银台"
        :close-on-click-modal="false"
        :before-close="close"
        custom-class="checkout-counter"
        width="948px"
      >
        <div class="pay-content" v-if="!scanningStatus">
          <div class="pay-content-title">扫一扫 完成支付</div>
          <div class="pay-content-price">
            <span class="unit">￥</span>
            <span class="price">{{ payPrice }}</span>
          </div>
          <div class="qr-code">
            <canvas ref="myCanvas" />
          </div>
          <div class="countdown-code">
            <span>二维码过期时间：{{ countDownSecond }}秒</span>
          </div>
          <div class="pay-way">
            <div class="pay-way-label">
              支持以下支付方式
            </div>
            <div class="pay-way-logos">
              <img src="@/assets/images/message/alipay.png" alt="" srcset="" />
              <img src="@/assets/images/message/wechat.png" alt="" srcset="" />
            </div>
          </div>
        </div>
        <div class="pay-success" v-if="scanningStatus">
          <img
            v-if="payStatus"
            src="@/assets/images/message/paysuccess.png"
            alt=""
          />
          <img
            v-if="!payStatus"
            src="@/assets/images/message/payfail.png"
            alt=""
          />
          <div class="pay-success-desc">
            {{ payStatus ? "支付成功" : "支付失败" }}
          </div>
          <div class="pay-success-buttons">
            <el-button size="small" @click="returnBack"
              >返回（{{ returnCountDownSecond }}）</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        :visible.sync="balanceSettingVisible"
        :close-on-click-modal="false"
        title="短信余额不足提醒"
        @open="alertDialog"
      >
        <el-form
          ref="balanceSetting"
          :model="balanceSettingForm"
          label-position="left"
          label-width="90px"
          size="small"
          :rules="rules2"
        >
          <el-form-item label="触发条件" prop="smsWarnQuantity">
            <div>
              <p>短信余额小于</p>
              <el-input
                v-model="balanceSettingForm.smsWarnQuantity"
                :maxlength="8"
              >
                <template slot="append">
                  条
                </template>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="短信提醒">
            <el-switch
              v-model="balanceSettingForm.smsWarnFlag"
              @change="enableChange"
              :active-value="1"
              :inactive-value="2"
            ></el-switch>
          </el-form-item>
          <el-form-item label="手机号" prop="smsWarnMobiles">
            <el-input
              v-model="balanceSettingForm.smsWarnMobiles"
            ></el-input>
          </el-form-item>
          <div style="margin-left: 90px">
            <p>多个手机号用“,”隔开，最多5个手机号。</p>
            <p>短信余额不足时，会发送对应信息至该手机号。</p>
          </div>
        </el-form>
        <template slot="footer">
          <el-button
            size="small"
            @click="balanceSettingVisible = false"
            v-loading="balanceSettingLoading"
            >取消</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="save()"
            v-loading="balanceSettingLoading"
            >确认</el-button
          >
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from "@/constants"
import { RULES } from "@/constants/rules"
import QrCode from "qrcode"
export default {
  name: "MessageAccount",
  data() {
    return {
      selectApp: "",
      appList: [],
      dialogVisible: false,
      dialogForm: {
        payType: "1",
        number: "",
      },
      totalPrice: 0, // 短信合计价格
      unitPrice: 0.01, // 短信单价
      payDialogVisible: false,
      timer: 0, // 轮巡查询状态timer
      countdowntimer: 0, // 过期倒计时timer
      payPrice: 0, // 付款价格
      countDownSecond: 899, // 支付码过期倒计时
      returnCountDownSecond: 5, // 返回按钮倒计时
      returnCountDownTimer: 0, // 返回倒计时timer
      payStatus: false, // 支付成功/失败
      scanningStatus: false, // 扫码状态-可以查出支付状态时true
      stockNum: 0,
      messageNumber: 0,
      orderNo: "",
      qrCode: "",
      rules: {
        number: [
          RULES.messageNumber,
          {
            required: true,
            message: "请输入自定义数量",
            trigger: ["blur", "change"],
          },
        ],
      },
      balanceSettingVisible: false, // 余额设置
      balanceSettingForm: {
        smsWarnQuantity: "",
        smsWarnFlag: 2,
      },
      
      balanceSettingLoading: false,
    }
  },
  async mounted() {
    // await this.getAppList()
    await this.getAccountInfo()
    await this.getPriceQuery()
    // 如果获取支付状态，存在代表刷新前在支付界面
    const status = localStorage.getItem("PAYSTATUS")
    const payInfo = localStorage.getItem("PAYINFO")
    if (status && payInfo) {
      const { qrCode, orderNo, amount } = JSON.parse(payInfo)
      this.payPrice = amount
      this.orderNo = orderNo
      this.dialogVisible = true
      this.payDialogVisible = true
      this.btn(qrCode)
      this.getPayStatus()
      this.countDown()
    }
  },
  destroyed() {
    this.clearAll()
  },
  computed:{
    rules2() {
      return{
        smsWarnQuantity: this.balanceSettingForm.smsWarnFlag === 1 ?[RULES.required,RULES.number]:[RULES.number],
        smsWarnMobiles: this.balanceSettingForm.smsWarnFlag === 1 ?[RULES.required, RULES.chMobile]:[RULES.chMobile],
      }
        
      },
  },
  methods: {
    // 预警弹框打开
    alertDialog() {
      console.log(12121)
      this.alertQuery()
    },
    async alertQuery() {
      // 获取短信余额预警
      const { code, msg, data } = await this.$API.alertQuery()
      if (code === RESPONSE_SUCCESS) {
        this.balanceSettingForm = data
      } else {
        this.$message.error(msg)
      }
    },
    enableChange(value) {
      if (!value) {
        this.$refs.balanceSetting.resetFields()
      }
    },
    save() {
      try {
        this.$refs.balanceSetting.validate(async (valid) => {
          this.balanceSettingLoading = true
          if (valid) {
            const { code, msg } = await this.$API.setupWarn(
              this.balanceSettingForm
            )
            if (code === RESPONSE_SUCCESS) {
              this.$message.success(msg)
              this.balanceSettingLoading = false
              this.balanceSettingVisible = false
            } else {
              this.balanceSettingLoading = false
              this.$message.error(msg)
            }
          }else{
            this.balanceSettingLoading = false
          }
        })
      } catch (error) {
        console.log(error)
      }
    },
    async getAccountInfo() {
      // 获取短信账余额
      const { code, msg, data } = await this.$API.stockQuery()
      if (code === RESPONSE_SUCCESS) {
        this.stockNum = data.stockNum
        this.selectApp = data.apiAccount
      } else {
        this.$message.error(msg)
      }
    },
    // 获取应用列表
    async getAppList() {
      const { code, data, msg } = await this.$API.appList()
      if (code === RESPONSE_SUCCESS) {
        this.appList = data
        this.selectApp = data[0].id
      } else {
        this.appList = []
        this.$message.error(msg)
      }
    },
    // 获取单价
    async getPriceQuery() {
      const { code, msg, data } = await this.$API.priceQuery()
      if (code === RESPONSE_SUCCESS) {
        this.unitPrice = data
      } else {
        this.$message.error(msg)
      }
    },
    appChange() {
      this.getAccountInfo()
    },
    // 点击购买按钮
    buyMessage() {
      this.dialogForm = {
        payType: "1",
      }
      this.payTypeChange(this.dialogForm.payType)
      this.dialogVisible = true
    },
    payTypeChange(type) {
      let price = ""
      switch (type) {
        case "1":
          price = 1000
          break
        case "2":
          price = 2000
          break
        case "3":
          price = 5000
          break
        case "4":
          price = 10000
          break
        default:
          break
      }
      this.messageNumber = price
      this.countPrice(price)
    },
    numberChange(val) {
      if (val % 1000 === 0) {
        this.countPrice(val)
      } else {
        this.countPrice(0)
      }
    },
    // 计算合计金额
    countPrice(val) {
      const num1 = this.unitPrice
      if (val) {
        const num2 = Number(val)
        //分别获取传入的两个数字的小数点后的位数
        var ext1Len = num1.toString().split(".")[1]
          ? num1.toString().split(".")[1].length
          : 0
        var ext2Len = num2.toString().split(".")[1]
          ? num2.toString().split(".")[1].length
          : 0

        //获取10的最大位数幂
        var m = Math.pow(10, Math.max(ext1Len, ext2Len))
        this.messageNumber = num2
        this.totalPrice = (num1 * m * num2 * m) / m / m
      } else {
        this.totalPrice = 0
      }
    },
    // 立即购买
    async buyNow() {
      const that = this
      this.$refs.buyInfoForm.validate(async (valid) => {
        if (valid) {
          const params = {
            number: that.messageNumber,
          }
          const { code, msg, data } = await that.$API.qrApply(params)
          if (code === RESPONSE_SUCCESS) {
            const { qrCode, orderNo, amount } = data
            that.payPrice = amount
            that.orderNo = orderNo
            that.payDialogVisible = true
            that.btn(qrCode)
            // 支付状态开启，在localStorage中存入状态
            localStorage.setItem("PAYSTATUS", true)
            localStorage.setItem("PAYINFO", JSON.stringify(data))
            that.getPayStatus()
            that.countDown()
          } else {
            that.$message.error(msg)
          }
        }
      })
    },
    btn(url) {
      // 判断url有没有值
      if (!url) return
      this.$nextTick(() => {
        // 如果这里 url 写的是网址, 就会跳转到对应网址 (二维码分享效果)
        QrCode.toCanvas(this.$refs.myCanvas, url)
      })
    },
    // 支付码过期倒计时
    countDown() {
      this.countdowntimer = setInterval(() => {
        this.countDownSecond--
        if (this.countDownSecond === 0) {
          this.countDownSecond = 899
          clearInterval(this.countdowntimer)
        }
      }, 1000)
    },
    // 轮巡支付状态
    // 10-待支付，15-二维码成功；18-扫码成功；20-支付成功；50-支付失败
    getPayStatus() {
      const that = this
      this.timer = setInterval(async () => {
        const params = { orderNo: this.orderNo }
        const { code, msg, data } = await that.$API.qrQuery(params)
        if (code === RESPONSE_SUCCESS) {
          const { resultCode } = data
          const finishStatus = [20, 50]
          // 轮巡支付状态
          if (finishStatus.includes(resultCode)) {
            // 20-支付成功；50-支付失败时候停止轮巡
            try {
              that.clearAll()
              that.scanningStatus = true
              if (resultCode === 20) {
                // 支付成功
                that.payStatus = true
              } else {
                that.payStatus = false
              }
              that.returnCountdown()
            } catch (error) {
              console.log(error)
            }
          }
        } else {
          this.$message.error(msg)
          this.clearAll()
        }
      }, 1000)
    },
    // 返回按钮
    returnBack() {
      if (this.payStatus) {
        // 支付成功，关闭所有
        this.dialogVisible = false
        this.getAccountInfo()
      }
      this.payTypeChange(this.dialogForm.payType)
      this.close()
    },
    returnCountdown() {
      const that = this
      try {
        this.returnCountDownTimer = setInterval(() => {
          console.log("================", that.returnCountDownSecond)
          that.returnCountDownSecond--
          if (that.returnCountDownSecond === 0) {
            that.returnBack()
          }
        }, 1000)
      } catch (error) {
        console.log(error, "========================error")
      }
    },
    close() {
      // this.dialogVisible = false
      this.payDialogVisible = false
      this.clearAll()
    },
    // 清除循环、移除支付状态、重置倒计时
    clearAll() {
      this.countDownSecond = 899
      this.returnCountDownSecond = 5
      localStorage.removeItem("PAYSTATUS")
      localStorage.removeItem("PAYINFO")
      this.scanningStatus = false
      this.payStatus = false
      clearInterval(this.timer)
      clearInterval(this.countdowntimer)
      clearInterval(this.returnCountDownTimer)
    },
  },
}
</script>

<style lang="scss" scoped>
.message-account {
  ::v-deep .el-input {
    width: 100%;
  }
  .info-item-title {
    display: flex;
    align-items: center;
  }
  .info-item-content {
    border: 1px solid #dedede;
    border-radius: 4px;
    margin-top: 15px;
    padding: 20px;
    font-size: 16px;
    line-height: 22px;
    &_top {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    p {
      padding-bottom: 6px;
    }
    .info-numbers {
      font-size: 20px;
      font-weight: 700;
      line-height: 25px;
      color: #2b2b2b;
      padding-bottom: 12px;
    }
  }
  .account-buy {
    margin-top: 30px;
    .buy-item-step {
      margin-top: 59px;
      display: flex;
      align-items: center;
      justify-content: center;
      .step-item {
        width: 256px;
        text-align: center;
        // font-size: 12px;
        img {
          width: 78px;
        }
        .step-item-label {
          margin-top: 20px;
          line-height: 22px;
          color: #2b2b2b;
        }
      }
      .line {
        img {
          width: 18px;
        }
      }
    }
    .buy-item-content {
      border: 1px solid #dedede;
      border-radius: 4px;
      background: #f9f9f9;
      margin-top: 35px;
      padding: 20px;
      line-height: 22px;
      padding-bottom: 24px;
      .buy-item-content-title {
        font-weight: 500;
        color: #2b2b2b;
      }
      .buy-item-content-row {
        margin-top: 20px;
        span {
          color: rgba(43, 43, 43, 0.9);
        }
        .buy-item-content-item {
          display: inline-block;
          width: 100px;
          text-align: right;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }
}
.buy-dialog {
  .el-radio-group {
    .el-radio {
      margin-right: 16px;
      margin-left: 0;
      width: 169px;
      height: 60px;
      padding: 14px 20px;
      margin-bottom: 16px;
      &.is-bordered.is-checked {
        background: url("../../../assets/images/message/checked.png") no-repeat
          right bottom;
        background-size: 26px;
      }
      &.is-bordered {
        border-radius: 4px;
      }
      &.customize-radio ::v-deep .el-radio__label {
        font-size: 18px;
        font-weight: 600;
      }
      .unit {
        font-size: 16px;
        margin-left: 2px;
        font-weight: 400;
      }
    }
    ::v-deep .el-radio__input {
      display: none !important;
    }
    ::v-deep .el-radio__label {
      padding-left: 0px;
      font-size: 26px;
      font-weight: 700;
      line-height: 32px;
      color: rgba(0, 0, 0, 0.9);
      letter-spacing: 0.8px;
    }
  }
  .price-unit,
  .price-total {
    color: #e60000;
  }
  .price-unit {
    margin-right: 4px;
    font-size: 24px;
    line-height: 28px;
  }
  .price-total {
    line-height: 44px;
    font-size: 36px;
    font-weight: 700;
  }
  ::v-deep .el-input {
    width: 100%;
  }
  .buy-now-button {
    margin: 12px;
  }
  .buy-row {
  }
  .label {
    display: inline-block;
    width: 100px;
  }
  .el-form {
    padding: 6px 12px;
    ::v-deep .el-form-item__label {
      font-size: 16px !important;
      text-align: right;
      padding-right: 48px;
    }
    ::v-deep .el-input-number--small {
      width: 354px;
    }
    .count-price {
      display: flex;
      align-items: center;
      ::v-deep .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
}
::v-deep .el-input-number .el-input__inner {
  text-align: left;
}
.title-left {
  width: 3px;
  height: 18px;
  background: #e60000;
  display: inline-block;
  margin-right: 10px;
}
.title-label {
  margin-right: 10px;
  display: inline-block;
  font-size: 16px;
  color: #2b2b2b;
  font-weight: 500;
  line-height: 24px;
}
.accountId {
  color: #2b2b2b;
  line-height: 24px;
}
.pay-content {
  padding: 16px 12px;
  text-align: center;
  &-title {
    font-size: 16px;
    line-height: 22px;
    color: #2b2b2b;
  }
  &-price {
    color: #e60000;
    margin-top: 8px;
    .unit {
      font-size: 24px;
      line-height: 28px;
      margin-right: 4px;
    }
    .price {
      font-size: 36px;
      font-weight: 700;
      line-height: 44px;
    }
  }
  .qr-code {
    width: 240px;
    height: 240px;
    border: 1px solid #dddddd;
    border-radius: 6px;
    margin: 12px auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .countdown-code {
    width: 240px;
    height: 30px;
    margin: 12px auto;
    background: linear-gradient(
      90deg,
      rgba(244, 0, 0, 0),
      rgba(230, 0, 0, 0.12) 51%,
      rgba(230, 0, 0, 0)
    );
    color: #e60000;
    font-size: 14px;
    line-height: 30px;
  }
  .pay-way {
    margin: 16px auto;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    &-label {
      line-height: 20px;
    }
    &-logos {
      margin: 8px auto;
      img {
        width: 32px;
        height: 32px;
        margin: 0 6px;
      }
    }
  }
}
.pay-success {
  text-align: center;
  margin-top: 48px;
  img {
    width: 88px;
    height: 88px;
  }
  &-desc {
    margin-top: 8px;
    text-align: center;
    font-size: 20px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.9);
    line-height: 28px;
  }
  &-buttons {
    margin-top: 24px;
  }
}
</style>

<style lang="scss">
.buy-dialog,
.checkout-counter {
  .el-dialog__header {
    border-bottom: 1px solid #f2f2f2;
    padding: 20px 32px 10px 32px;
  }
}
</style>
